import { Autocomplete, Box, Button, Chip, Grid, Stack, TextField, Typography } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'

export interface AssetsFolderEditPanelProps {
    tagList: string[]
    onCancel: () => void
    onSubmit: (title: string, tags: string[]) => void
}

interface AssetsFolderEditPanelInputs {
    Title: string
    Tags: string[]
}

const AssetsFolderEditPanel = (props: AssetsFolderEditPanelProps): JSX.Element => {
    const { onCancel, onSubmit, tagList } = props
    const { handleSubmit, control } = useForm<AssetsFolderEditPanelInputs>({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
        defaultValues: {
            Title: '',
            Tags: [],
        },
    })

    const handleOnSave = () => {
        handleSubmit((data: AssetsFolderEditPanelInputs) => {
            onSubmit(data.Title, data.Tags)
        })()
    }

    return (
        <Box display="flex" flexDirection="column" flex={1} p={2}>
            <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
                <Typography variant="h6">Create fodler</Typography>
            </Grid>
            <Grid container mb={2}>
                <Controller
                    name="Title"
                    control={control}
                    rules={{
                        required: 'Please enter a name for the folder',
                        maxLength: { value: 150, message: 'The order name may only be 150 characters long.' },
                    }}
                    render={({ field, fieldState }) => (
                        <TextField
                            label="Title"
                            inputProps={{ maxLength: 150 }}
                            variant={'filled'}
                            fullWidth={true}
                            {...field}
                            helperText={fieldState.error?.message ?? ''}
                        />
                    )}
                />
            </Grid>
            <Grid container mb={2}>
                <Controller
                    name="Tags"
                    control={control}
                    render={({ field }) => (
                        <Autocomplete
                            multiple
                            fullWidth
                            id="Tags"
                            options={tagList}
                            freeSolo
                            renderTags={(value: readonly string[], getTagProps) =>
                                value.map((option: string, index: number) => (
                                    // eslint-disable-next-line react/jsx-key
                                    <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                ))
                            }
                            onChange={(event, value) => {
                                field.onChange(value)
                            }}
                            renderInput={(params) => <TextField {...params} variant="filled" label="Tags" />}
                        />
                    )}
                />
            </Grid>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                <Button variant="contained" color={'secondary'} onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleOnSave}>
                    Save
                </Button>
            </Stack>
        </Box>
    )
}

export default AssetsFolderEditPanel
